import Autolinker from 'autolinker';

const turnUrlIntoLink = (urlString: Nullable<string>) => {
  if (typeof urlString !== 'string') {
    return null;
  }

  return Autolinker.link(urlString, { stripPrefix: false });
};

export default turnUrlIntoLink;
